import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Container,
    Card,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select'
import MetaTags from "react-meta-tags"
import BaseService from "services/BaseService";
import CanvasFabric from "./CanvasFabric"
import UploadImage from "./UploadImage"
import "./style.scss"


const ImagesData = [
    {
        id: "25",
        path: "http://localhost:8000/uploads/images/G9BgLFn0eROJUC9zpK5UkW8Ugw74rnZLh8pbfgDw.jpg",
        shapes: [{
            type: "Rect",
            left: 200,
            top: 200,
            stroke: 'red',
            strokeWidth: 2,
            fill: "transparent",
            width: 100,
            height: 100,
            id: "mckccjckcccckckcllc",
            description: "Rect say Hello From image Id number 25",
            navigateTo: "24"
        }, {
            type: "Circle",
            radius: 50,
            fill: 'rgba(0,0,0,0)',
            left: 0,
            stroke: "red",
            top: 100,
            strokeWidth: 2,
            id: "mckccjckclfkkfccckckcllc",
            description: "Circle say Hello From image Id number 25",
            navigateTo: "23"
        }, {
            type: "node",
            left: 400,
            top: 100,
            id: "mckccjckcccckasddckcllc",
            description: "node say Hello From image Id number 25",
            navigateTo: "24"
        }]
    }, {
        id: "24",
        path: "http://localhost:8000/uploads/images/cXt0ib0oogJm6Fgc1xdwabMKD2zNC0cci9fPhbdw.jpg",
        shapes: [{
            type: "Rect",
            left: 50,
            top: 70,
            stroke: 'red',
            strokeWidth: 2,
            fill: "transparent",
            width: 100,
            height: 100,
            id: "mckccjckcccckffldckcllc",
            description: "Rect say Hello From image Id number 24",
            navigateTo: "25"
        }, {
            type: "Circle",
            radius: 50,
            fill: 'rgba(0,0,0,0)',
            left: 200,
            stroke: "red",
            top: 100,
            strokeWidth: 2,
            id: "mckccjckcccckck66jekcllc",
            description: "Circle say Hello From image Id number 24",
            navigateTo: "25"
        }, {
            type: "node",
            left: 10,
            top: 190,
            id: "mckccjckcccckckc66lckdcllc",
            description: "node say Hello From image Id number 24",
            navigateTo: "23"
        }]
    }, {
        id: "23",
        path: "http://localhost:8000/uploads/images/D5PADhJGX0oTZoIC83FUl8pVvyLLGdkrHgr1L82P.png",
        shapes: [{
            type: "Rect",
            left: 0,
            top: 0,
            stroke: 'red',
            strokeWidth: 2,
            fill: "transparent",
            width: 200,
            height: 100,
            id: "dlddkjdkdddhhd66",
            description: "Rect say Hello From image Id number 23",
            navigateTo: "24"
        }, {
            type: "Circle",
            radius: 80,
            fill: 'rgba(0,0,0,0)',
            left: 400,
            stroke: "red",
            top: 100,
            strokeWidth: 2,
            id: "mckccjckccldkdlc57cckckcllc",
            description: "Circle say Hello From image Id number 23",
            navigateTo: "24"
        }, {
            type: "node",
            left: 150,
            top: 100,
            id: "mckccjckccdlldd556cckckcllc",
            description: "node say Hello From image Id number 23",
            navigateTo: "25"
        }]
    }
]

const UserMode = () => {
    const [modeData, setModata] = useState([])
    const [activeCanvas, setActiveCanvas] = useState(null)
    const [canvas, setCanvas] = useState('');
    const [toolTipData, setToolTipData] = useState('');

    const myStateRef = useRef(activeCanvas)

    useEffect(() => {
        document.documentElement.webkitRequestFullscreen()
    }, []);
    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`, {
            height: 600,
            width: 600,
        })
        // background image shoulf reset with every change in the canvas  
        // (chexk it in admin page)
        new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                scaleX: canvas.width / img.width,
                scaleY: canvas.height / img.height
            });
        })


        return canvas
    }
    useEffect(() => {
        setCanvas(initCanvas());
    }, []);

    const loadData = async() => {

        const data =  localStorage.getItem("interactiveMode")
        const parseData =  JSON.parse(data)
       
if(parseData){
    const images = parseData.images
      setModata(images)
}else{
    setModata([])

}

    }
    useEffect(() => {
        loadData()
        // setModata(ImagesData)
        // const data=localStorage.getItem("interactiveMode")
        // const parseData=JSON.parse(data)
        // setModata(parseData)
    }, [])

    useEffect(() => {
        setActiveCanvas(modeData[0])
    }, [modeData])


    const renderSavedCanvasData = async (activeCanvas) => {
        if (canvas !== "") {
            await canvas.clear()
            await canvas.renderAll();
            //  myStateRef.current = activeCanvas

            new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
                canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                    scaleX: canvas.width / img.width,
                    scaleY: canvas.height / img.height
                });
            })
             fabric.Canvas.prototype.setCursor
                = function (value) {
                     value = 'pointer'; // Add your own logic here to override
                    this.upperCanvasEl.style.cursor = value;
                };
            activeCanvas ?.shapes ?.forEach((shape, index) => {
                if (shape.type === "Circle") {
                    var circle = new fabric.Circle(shape);
                    circle.set('selectable', false)

                    canvas.add(circle);
                } else if (shape.type === "Rect") {
                    var rect = new fabric.Rect(shape);
                    rect.set('selectable', false)

                    canvas.add(rect);
                } else {
                    var node = new fabric.Circle({
                        radius: 20,
                        fill: 'rgba(0,0,0,0)',
                        left: 0,
                        stroke: "red",
                        top: 30,
                        strokeWidth: 4,
                    });
                    var nodeChild = new fabric.Circle({
                        radius: 10,
                        fill: 'rgba(0,0,0,0)',
                        left: 12,
                        fill: "red",
                        top: 42,
                    });
                    var group = new fabric.Group([node, nodeChild], shape)
                    group.set('selectable', false)

                    canvas.add(group);
                }
            })

            canvas.renderAll();
        }
    }
    useEffect(() => {
        if (canvas !== "") {
            canvas.on('mouse:over', function (e) {
                const value = e.target
                if (value) {
                    const tt = document.getElementById("toolTip")
                    setToolTipData(value.description)
                    tt.style.visibility = 'visible'
                    tt.style.top = `${e ?.target ?.top + e ?.target ?.height + 0}px`
                    tt.style.left = `${e ?.target ?.left + e ?.target ?.width + 0}px`
                }
            })
            canvas.on('mouse:out', function (e) {
                const value = e.target

                if (value) {
                    setToolTipData("")
                    const tt = document.getElementById("toolTip")
                    if (e.target) {
                        tt.style.visibility = 'hidden'
                    }
                }

            })
            canvas.on('mouse:down', (e) => {
                const value = e.target
                if (value) {
                    const tt = document.getElementById("toolTip")
                    tt.style.visibility = 'hidden'
                    const navigateTo = value.navigateTo
                    const canvasTarget = modeData.filter(item => {
                         return item.id === parseInt(navigateTo)
                    })
                     setActiveCanvas(canvasTarget[0])

                } 
            });
        }

    }, [canvas])

    useEffect(() => {
        renderSavedCanvasData(activeCanvas)
    }, [activeCanvas])

 
    const myDiv = document.getElementById('toolTip');
   
    myDiv?.addEventListener("mouseover", function( event ) {
        // highlight the mouseover target
        myDiv.style.visibility = 'visible'
       
      }, false);

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Interactive  Mode</title>
                </MetaTags>
                <Container fluid className="bg-light">
                    <Row>
                        {activeCanvas
                            ?
                            <Col md={12}>
                                <span id="toolTip"  >{toolTipData}</span>
                                <canvas id={`canvas`} width="1000" height="500" style={{ objectFit: "cover" }}></canvas>
                            </Col> : <Col md={12}>
                                <span id="toolTip"  >{toolTipData}</span>
                                <canvas id={`canvas`} width="1000" height="500" style={{ objectFit: "cover" }}></canvas>
                            </Col>}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default UserMode